import { createFileRoute, redirect } from "@tanstack/react-router";

// Alias route: /app/chat/$matterId → /app/matters/$matterId (RAG chat lives there)
export const Route = createFileRoute("/_authenticated/app/chat/$matterId")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/app/matters/$matterId", params: { matterId: params.matterId } });
  },
  component: () => null,
});
